import { ToastService } from '../shared/services/toast.service';
import { ERROR } from '../shared/constants';

export class AppNotify {

  private static get service(): ToastService | null {
    return ToastService.getInstance();
  }

  static info(message: string, displayTime = 5000) {
    this.service?.info(message, displayTime);
  }

  static warning(message: string, displayTime = 5000) {
    this.service?.warning(message, displayTime);
  }

  static error(message = '', displayTime = 5000) {
    if (!message) {
      message = ERROR;
    }
    this.service?.error(message, displayTime);
  }

  static success(message: string, displayTime = 5000) {
    this.service?.success(message, displayTime);
  }

  static confirm(message: string, title: string): Promise<boolean> {
    const svc = this.service;
    if (svc) {
      return svc.confirm(message, title);
    }
    return Promise.resolve(false);
  }

  static alert(message: string, _title: string): Promise<void> {
    this.service?.info(message, 5000);
    return Promise.resolve();
  }
}
